import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Config } from '../.env.js';
import { useParams } from 'react-router-dom'; // ⬅️ Important
import Footer from './Footer.js';
import Header from './Header.js';

const CampaignDetails = ({ alignLeft }) => {
    const { campaignName } = useParams(); // ⬅️ Get from URL

    const [product, setProduct] = useState(null);
    const [products, setProducts] = useState([]);

    const [formData, setFormData] = useState({
        AuthContact: '',
        AuthEmail: '',
        brandLogo: '',
    });

    useEffect(() => {
        axios.get(`${Config.API_URL}/api/getCampaign`)
            .then(response => {
                const campaignData = response.data.find(c => c.campaignName === campaignName);
                if (campaignData) {
                    setFormData({
                        AuthContact: campaignData.campaignName,
                        AuthEmail: campaignData.campaignRulesDescription,
                        brandName: campaignData.brandName,
                        brandLogo: campaignData.brandLogo,

                    });
                }
            })
            .catch(error => {
                console.error('Error fetching campaign data:', error);
            });
    }, [campaignName]);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                const response = await axios.get(`${Config.API_URL}/api/product`, {
                    params: { campaignName }
                });
                setProducts(response.data);
            } catch (error) {
                console.error("Error fetching product:", error);
            }
        };

        if (campaignName) {
            fetchProduct();
        }
    }, [campaignName]);
    const stripHtmlTags = (html) => {
        const tempDiv = document.createElement("div");
        tempDiv.innerHTML = html;
        return tempDiv.textContent || tempDiv.innerText || "";
    };
    return (
        <>
            <Header />
            <div style={{ display: "flex", justifyContent: "center" }}>
                <div className='card' >
                    <form>
                        <div className="field" style={{ width: "1440px" }}>
                            <h1 className='title has-text-centered mt-5'>Campaign</h1>
                        </div>
                        <div className='field'>
                            <label className="label has-text-left">Brand Name*</label>
                            <textarea
                                className="textarea"

                                value={stripHtmlTags(formData.brandName)}
                                readOnly
                            />
                        </div>
                        {formData.brandLogo && (
                            <div className="field">
                                <label className="label has-text-left">Brand Logo</label>
                                <img
                                    src={`${Config.API_URL}/${formData.brandLogo}`}
                                    alt="Brand Logo"
                                    style={{
                                        maxWidth: '150px',
                                        maxHeight: '150px',
                                        borderRadius: '8px',
                                        objectFit: 'cover'
                                    }}
                                />
                            </div>
                        )}
                        <div className='field is-small'>
                            <label className="label has-text-left">Campaign Name*</label>
                            <input
                                className="input"
                                type="text"
                                value={formData.AuthContact}
                                readOnly
                            />
                        </div>

                        <div className='field'>
                            <label className="label has-text-left">Campaign Rules Description*</label>
                            <textarea
                                className="textarea"

                                value={stripHtmlTags(formData.AuthEmail)}
                                readOnly
                            />
                        </div>

                        <div className="field is-small">
                            <label className="label has-text-left">Item Name(s)*</label>
                            {products.length > 0 ? (
                                products.map((item, index) => (
                                    <input
                                        key={index}
                                        className="input mb-2"
                                        type="text"
                                        value={item.productName}
                                        readOnly
                                    />
                                ))
                            ) : (
                                <p className='has-text-weight-bold'>Item name not available</p>
                            )}
                        </div>

                    </form>
                </div>
            </div >
            <Footer />
        </>
    );
};

export default CampaignDetails;
